import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Force reload
import LanguageDetector from 'i18next-browser-languagedetector';

import translationES from './locales/es/translation.json';
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationDE from './locales/de/translation.json';
import translationIT from './locales/it/translation.json';
import translationPT from './locales/pt/translation.json';
import translationPL from './locales/pl/translation.json';

import marketingES from './locales/es/marketing.json';
import marketingEN from './locales/en/marketing.json';
import marketingFR from './locales/fr/marketing.json';
import marketingDE from './locales/de/marketing.json';
import marketingIT from './locales/it/marketing.json';
import marketingPT from './locales/pt/marketing.json';
import marketingPL from './locales/pl/marketing.json';
import exercisesES from './locales/es/exercises.json';
import exercisesEN from './locales/en/exercises.json';
import exercisesFR from './locales/fr/exercises.json';
import exercisesDE from './locales/de/exercises.json';
import exercisesIT from './locales/it/exercises.json';
import exercisesPT from './locales/pt/exercises.json';
import exercisesPL from './locales/pl/exercises.json';

const resources = {
    es: { translation: translationES, marketing: marketingES, exercises: exercisesES },
    en: { translation: translationEN, marketing: marketingEN, exercises: exercisesEN },
    fr: { translation: translationFR, marketing: marketingFR, exercises: exercisesFR },
    de: { translation: translationDE, marketing: marketingDE, exercises: exercisesDE },
    it: { translation: translationIT, marketing: marketingIT, exercises: exercisesIT },
    pt: { translation: translationPT, marketing: marketingPT, exercises: exercisesPT },
    pl: { translation: translationPL, marketing: marketingPL, exercises: exercisesPL }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en', // Default to English if detection fails
        debug: false, // Disable debug in production

        interpolation: {
            escapeValue: false // React already safes from xss
        },

        detection: {
            order: ['querystring', 'localStorage', 'navigator'], // Check URL first (important for SEO hreflang), then localStorage
            caches: ['localStorage'],
            lookupQuerystring: 'lng',
            lookupLocalStorage: 'i18nextLng'
        }
    });

export default i18n;
